t = require('app/scripts/views/internal/teacup-with-helpers')('header_warning_personal_boards_ownership')

module.exports = t.renderable ({ enterpriseName, date }) ->
  t.div ->
    t.span '.personal-boards-message', ->
      t.format 'security-updates-are-coming-on', { date }
    t.a '.personal-boards-learn-more', { href: "/enterprise/#{enterpriseName}/personal-boards", target: 'blank' }, ->
      t.format 'learn-how-this-will-affect-your-boards'

    t.a '.quiet.sso-notice-dismiss.js-dismiss-personal-boards-ownership.u-float-right', { href: "#" }, ->
      t.icon 'close'
